import { pollJSONUntil } from "../framework/api";

const pollTimeoutMs = 2000;

// processStateCallback should return false to stop polling
export function startPollingAsyncJob(asyncJobId, processStateCallback) {
  pollJSONUntil((state) => !processStateCallback(state), p`/ajax/async_jobs/${asyncJobId}`, undefined, pollTimeoutMs).catch(() => {
    processStateCallback(null);
  });
}
